'use strict';

module.exports = function reject(fn) {
  return new this.constructor(this.items.filter(function (item) {
    return !fn(item);
  }));
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/reject.js
// module id = 1268
// module chunks = 2